<template>
  <div class="payment-card">
    <h1 class="text-center page-title" style="color: hsla(0, 0%, 100%, .8); padding-top: 40px">Байгууллагын код
      оруулах</h1>

    <InputText
        size="small"
        type="text"
        class="card-input"
        style="background: grey;color: white"
        v-model="code"
        placeholder="Байгууллагын кодоо оруулна уу"
        autocomplete="off"
    />
    <ProgressSpinner v-if="btnLoading" style="width:50px;height:50px" strokeWidth="3" animationDuration="1s"/>
    <Button v-else @click="submitForm">Илгээх</Button>

    <Message severity="error" v-if="error">{{ msg }}</Message>
    <Message severity="success" v-if="success">Байгууллагын код амжилттай илгээгдлээ.</Message>
  </div>
</template>
<style>
.card-input::placeholder {
  color: lightgray;
}
</style>
<script>
import Message from 'primevue/message';
import api from "../../store/_boot/baseApi";

export default {
  name: "card.vue",
  components: {
    Message
  },
  data() {
    return {
      btnLoading: false,
      error: false,
      success: false,
      code: "",
      msg: ""
    }
  },
  methods: {
    submitForm() {
      this.success = false;
      this.error = false;
      if (this.code === '') {
        this.$toast.error('Байгууллагын кодоо оруулна уу');
        return;
      }

      this.btnLoading = true;

      api.post("/api/receipt/aan/register", {
        "tax_reg": this.code
      }).then(({data}) => {
        if (data.status) {
          this.success = true;
          this.error = false;
          this.msg = data.msg;
          this.$router.push("/payment");
        } else {
          this.success = false;
          this.error = true;
          this.msg = data.msg;
        }
        this.btnLoading = false;
      }).catch(e => {
        console.log(e);
        this.btnLoading = false;
        this.success = false;
        this.error = true;
        this.msg = 'Алдаа гарлаа';
      })
    },
  }
}
</script>
